var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.593,
    height: 29.305,
    viewBox: "0 0 31.593 29.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(-2.64 -1.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5531",
    "data-name": "Pfad 5531",
    d: "M30.209,17.217V15.666l2.147-1.7a1.9,1.9,0,0,0,.424-2.585L30.142,7.323a2.288,2.288,0,0,0-1.934-1.014,2.449,2.449,0,0,0-.716.1l-2.718.831a13.085,13.085,0,0,0-1.465-.761l-.571-2.555A2.2,2.2,0,0,0,20.5,2.295H15.268a2.2,2.2,0,0,0-2.237,1.632l-.571,2.555a13.245,13.245,0,0,0-1.476.761L8.324,6.37a2.459,2.459,0,0,0-.715-.06A2.288,2.288,0,0,0,5.675,7.323L3.036,11.378a1.9,1.9,0,0,0,.458,2.545l2.113,1.754v1.551l-2.113,1.7a1.9,1.9,0,0,0-.458,2.585L5.675,25.57a2.288,2.288,0,0,0,1.934,1.014,2.448,2.448,0,0,0,.716-.1l2.718-.831a13.085,13.085,0,0,0,1.465.761l.571,2.555A2.2,2.2,0,0,0,15.315,30.6h5.278a2.2,2.2,0,0,0,2.237-1.632l.571-2.555a13.245,13.245,0,0,0,1.476-.761l2.707.831a2.448,2.448,0,0,0,.716.1,2.288,2.288,0,0,0,1.934-1.014l2.55-4.055a1.9,1.9,0,0,0-.458-2.545Zm-2,7.339L24.371,23.38a10.2,10.2,0,0,1-3.031,1.591l-.793,3.639H15.269l-.794-3.6a10.767,10.767,0,0,1-3.02-1.591L7.609,24.556,4.97,20.5l3.042-2.433a8.193,8.193,0,0,1,0-3.173l-3.042-2.5L7.609,8.337l3.836,1.176a10.2,10.2,0,0,1,3.031-1.591l.793-3.639h5.278l.794,3.6a10.767,10.767,0,0,1,3.02,1.591l3.846-1.135,2.639,4.055L27.8,14.825A8.193,8.193,0,0,1,27.8,18l3.042,2.5Z",
    transform: "translate(0.523 -0.313)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5532",
    "data-name": "Pfad 5532",
    d: "M16.3,21.205a4.978,4.978,0,1,1,5.052-4.978,4.891,4.891,0,0,1-1.465,3.534A5.04,5.04,0,0,1,16.3,21.205Zm0-8.3a3.318,3.318,0,0,0-2.4.949,3.395,3.395,0,0,0,0,4.738,3.52,3.52,0,0,0,4.809,0,3.395,3.395,0,0,0,0-4.738,3.318,3.318,0,0,0-2.4-.949Z",
    transform: "translate(2.135 -0.094)",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.3b3cb42c490afbdfe9c87a95ceb390b4.svg";
export { ForwardRef as ReactComponent };